module.exports = __webpack_public_path__ + "img/settings_960.f9d71527.webp";